// extracted by mini-css-extract-plugin
module.exports = {"title":"Footer_title__i70z2","app-image":"Footer_app-image__lkfL_"};